<script setup lang="ts">
import { formatCurrency, dateRelative } from "@/libs/filters";
import { useCordovaStore } from "@/stores/cordova";

defineProps(["ads"]);
const cordovaStore = useCordovaStore();
const openAd = function (link: string) {
  if (cordovaStore.isLoaded) {
    cordovaStore.openInExternalBrowser(link);
  } else {
    window.open(link, "_blank");
  }
};
</script>

<template>
  <div class="ads table-view">
    <table class="table table-dark table-striped">
      <thead>
        <tr>
          <th class="center d-none d-sm-table-cell">Foto</th>
          <th>Modelo</th>
          <th class="right">Preço</th>
          <th>Localização</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="ad of ads" :key="ad.id">
          <td class="center d-none d-sm-table-cell">
            <img
              v-if="ad.imagesUrl.length"
              class="image"
              :src="ad.imagesUrl[0]"
              alt=""
              width="42"
              height="42"
            />
          </td>
          <td>
            <a
              :href="ad.link"
              class="link"
              target="_blank"
              rel="nofollow noopener noreferrer"
              @click.prevent="openAd(ad.link)"
            >
              <template v-if="ad.brandName">
                {{ ad.brandName }}
              </template>
              <span v-if="ad.modelName" class="model">
                {{ ad.modelName }}
              </span>
              <template v-if="ad.year">
                {{ ad.year }}
              </template>
              <template v-if="ad.variantName"
                ><br />{{ ad.variantName.toUpperCase() }}</template
              >
            </a>
          </td>
          <td class="right">
            <template v-if="ad.price">
              {{ formatCurrency(ad.price) }}
            </template>
            <template v-if="ad.fipePercent">
              <br />{{ (ad.fipePercent * 100).toFixed(0) }}% da FIPE
            </template>
          </td>
          <td>
            {{ dateRelative(ad.createdAt) }}
            <br />em {{ ad.city }} - {{ ad.state }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.table-view {
  overflow-y: auto;
  border-radius: 0.5rem;
}

.table {
  border-radius: 0.5rem;
}

.table thead tr th:first-child {
  border-radius: 0.5rem 0 0 0;
}

.table thead tr th:last-child {
  border-radius: 0 0.5rem 0 0;
}

.table tbody tr:last-child td:first-child {
  border-radius: 0 0 0 0.5rem;
}

.table tbody tr:last-child td:last-child {
  border-radius: 0 0 0.5rem 0;
}

.table tbody tr:last-child td {
  border-bottom-width: 0;
}

.table > :not(:first-child) {
  border-top-color: var(--primary-color);
}

.table > :not(caption) > * > * {
  background-color: var(--black-eigengrau);
  border-bottom-width: 0px;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: var(--dark-color);
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.link {
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.image {
  object-fit: cover;
}

@media (max-width: 575.98px) {
  .table {
    font-size: 0.9rem;
  }
}
</style>
